import React from 'react';
import DiagExchangeHistoryDetailEdit from '@di-shared/features/diag/exchange/history/DiagExchangeHistoryDetailEdit';

interface DiagExchangeHistoryDetailEditPageProps {
  vin: string;
  historyId: string;
}
function DiagExchangeHistoryDetailEditPage({vin, historyId}: DiagExchangeHistoryDetailEditPageProps) {
  return (
    <DiagExchangeHistoryDetailEdit
      vin={vin}
      historyId={historyId}
    />
  );
}

export default DiagExchangeHistoryDetailEditPage;
